import { sendGAEvent } from '../utils';

export enum NdbEvents {
  NDB_CONFIRM_EMAIL_POPUP_APPEARANCE = 'ndb_confirm_email_popup_appearance',
  NDB_ACTIVATE_BONUS_POPUP_APPEARANCE = 'ndb_activate_bonus_popup_appearance',
  NDB_PROMO_CODE_APPLY = 'ndb_promo_code_apply',
}

const NDB_CATEGORY = 'ndb';

interface INdbPromoCodeEvent {
  code: string;
  status: 'success' | 'failed';
  error_data?: unknown;
}

/**
 * @description Appearance of the first NDB popup, telling the player to confirm
 * their email before the no deposit bonus can be activated.
 */
export const sendNdbConfirmEmailPopupAppearanceEvent = () => {
  sendGAEvent(NdbEvents.NDB_CONFIRM_EMAIL_POPUP_APPEARANCE, {
    event_category: NDB_CATEGORY,
  });
};

/**
 * @description Appearance of the second NDB popup, telling the player their
 * email is confirmed.
 */
export const sendNdbActivateBonusPopupAppearanceEvent = () => {
  sendGAEvent(NdbEvents.NDB_ACTIVATE_BONUS_POPUP_APPEARANCE, {
    event_category: NDB_CATEGORY,
  });
};

/**
 * @description Click on "Activate" for a promo code the player typed in.
 */
export const sendNdbPromoCodeApplyEvent = (data: INdbPromoCodeEvent) => {
  sendGAEvent(NdbEvents.NDB_PROMO_CODE_APPLY, {
    event_category: NDB_CATEGORY,
    ...data,
  });
};
